module.exports = __webpack_public_path__ + "static/jewelbotsgroup-0ea62c3f0768d071888faa713db2db4b.jpg";